<template>
  <div>
    <div class="right-title">
      <span>新闻资讯</span>
      <el-button plain class="go-back" @click="goBack">返回</el-button>
    </div>
    <div class="content-box">
      <el-form :model="ruleForm" ref="ruleForm" label-width="150px" class="demo-ruleForm">
        <el-form-item label="标题:" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="内容:" prop="content">
          <div style="height: 450px;">
            <quill class="quill" @getData="getData" :contents="ruleForm.content"></quill>
          </div>
        </el-form-item>
        <el-form-item label="缩略图:" >
          <el-upload
            class="avatar-uploader"
            accept="image/*"
            action=""
            multiple
            :show-file-list="false"
            :before-upload="beforeAvatarUpload1">
            <img v-if="ruleForm.imageUrl1" :src="config.urlStr + '/' + ruleForm.imageUrl1" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()">立即发布</el-button>
          <el-button type="primary" @click="submitForm2()">保存草稿</el-button>
        </el-form-item>
      </el-form>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'
  import quill from '../../../../components/quill'
  import config from "@/config";
  export default {
    data(){
      return {
        config: config,
        ruleForm:{
          name:'',
          content:'',
          imageUrl1:''
        },
      }
    },
    computed: {
      user(){
        return this.$store.state.user
      }
    },
    created() {
      this.$emit('setType', 1)
      if(this.$route.query.id){
        this.getDetail()
      }
    },
    methods:{
      beforeAvatarUpload1(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        console.log(fd)
        this.$api.apiContent.file(fd).then(res => {
          this.ruleForm.imageUrl1 = res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
      },
      getDetail(){
        this.$api.apiContent.newDetail({
          id:this.$route.query.id
        }).then(res=>{
          this.ruleForm.name = res.data.title
          this.ruleForm.content = res.data.content
          this.ruleForm.imageUrl1 = res.data.thumb
        })
      },
      //  发送表单
      submitForm() {
        if(!this.ruleForm.name){
          this.$message.error('请填写标题')
          return
        }
        if(!this.ruleForm.content){
          this.$message.error('请填写内容')
          return
        }
        this.$api.apiContent.addNews({
          adminId:this.user.id,
          title:this.ruleForm.name,
          content:this.ruleForm.content,
          describe:this.ruleForm.content.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi,'').replace(/<[^>]+?>/g,'').replace(/\s+/g,' ').replace(/ /g,' ').replace(/>/g,' ').replace(/&nbsp;/gi,'').replace(/&amp;nbsp;/gi,''),
          thumb:this.ruleForm.imageUrl1,
          id:!this.$route.query.id?'':this.$route.query.id
        }).then(res=>{
          this.$message.success(res.info)
          this.$router.go(-1)
        }).catch(e=>{
          this.$message.error(e.info)
        })
      },
      submitForm2() {
        if(!this.ruleForm.name){
          this.$message.error('请填写标题')
          return
        }
        if(!this.ruleForm.content){
          this.$message.error('请填写内容')
          return
        }
        this.$api.apiContent.addNews({
          adminId:this.user.id,
          title:this.ruleForm.name,
          content:this.ruleForm.content,
          thumb:this.ruleForm.imageUrl1,
          describe:this.ruleForm.content.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi,'').replace(/<[^>]+?>/g,'').replace(/\s+/g,' ').replace(/ /g,' ').replace(/>/g,' ').replace(/&nbsp;/gi,'').replace(/&amp;nbsp;/gi,''),
          id:!this.$route.query.id?'':this.$route.query.id,
          type:2
        }).then(res=>{
          this.$message.success(res.info)
          this.$router.push('/home/newsAdmin/newsList')
        }).catch(e=>{
          this.$message.error(e.info)
        })
      },
      // 获取内容
      getData(data) {
        this.ruleForm.content = data
      },
      goBack() {     //  返回上一页
        this.$tools.goBack()
      },
    },
    watch:{

    },
    components:{
      footerBox,
      quill
    }
  }
</script>

<style scoped lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 386px;
  height: 220px;
  line-height: 140px;
  text-align: center;
  border: 1px dashed #8c939d;
}

.avatar {
  width: 386px;
  height: 220px;
  display: block;
}
</style>
